import "./Lumina.module.css";
import Navigation from "@/reusable_sections/Header";
import Engine from "./sections/Engine";
import Logic from "./sections/Logic";
import Architecture from "./sections/Architecture";
import Footer from "@/reusable_sections/Footer";
export default function LuminaPage() {
  return <div>
      <Navigation />
      <Engine />
      <Logic />
      <Architecture />
      <Footer />
    </div>;
}